export default {
  websiteBaseUrl: 'http://localhost:3000',
  apiBaseUrl: 'https://staging.roomvu.com/api',
  dashboardBaseUrl: 'http://localhost:3000/dashboard',
  imgBaseUrl: 'https://staging.roomvu.com/',
  useProxyForApiCall: true,
  displayAnalyticLogs: false,
  env: 'development',
  auth: {
    loginUrl: 'http://localhost:3000/signin',
    registerUrl: 'http://localhost:3000/register',
    loginApiUrl: '/user/login',
    userAuthenticationUrl: '/user/get',
  },
  googleCaptcha: {
    siteKey: '6LeuuJcUAAAAAJtpfdUpKvjxk62bbz3KCNVfGkuz',
  },
  intercom: {
    IntercomAppID: 'XXXXXXXXX',
  },
  intrack: {
    IntrackAppKey: 'XXXXXXXXX',
    IntrackAuthKey: 'XXXXXXXXX',
    IntrackPublicKey: 'XXXXXXXXX',
  },
  clarity: {
    projectId: 'XXXXXXXXXX',
  },
  webEngage: {
    licenseCode: '82617805',
  },
  facebook: {
    appId: '629792100977483',
  },
  sentry: {
    DSN: 'https://0f2b2605c4334568a8e46d435cc7f6f1@sentry.roomvu.com/5',
    environment: 'development',
  },
  stripe: {
    key: 'pk_test_SAS3NwDrUpHXlhtCUUVhe50t',
  },
};
